const AutotaskUsersImport = () => import('@/views/account/integrations/autotask/import/autotask-users-import-view.vue');
const AutotaskCompaniesImport = () => import('@/views/account/integrations/autotask/import/autotask-companies-import-view.vue');
const AutotaskContactsImport = () => import('@/views/account/integrations/autotask/import/autotask-contacts-import-view');
const AutotaskActivitiesImport = () => import('@/views/account/integrations/autotask/import/autotask-activities-import-view');
const AutotaskOpportunitiesImport = () => import('@/views/account/integrations/autotask/import/autotask-opportunities-import-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Autotask/Manage/Users/Import',
        name: 'AutotaskUsersImport',
        component: AutotaskUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Users/Import',
        name: 'ClientAutotaskUsersImport',
        component: AutotaskUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Autotask/Manage/Companies/Import',
        name: 'AutotaskCompaniesImport',
        component: AutotaskCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Companies/Import',
        name: 'ClientAutotaskCompaniesImport',
        component: AutotaskCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Autotask/Manage/Contacts/Import',
        name: 'AutotaskContactsImport',
        component: AutotaskContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Contacts/Import',
        name: 'ClientAutotaskContactsImport',
        component: AutotaskContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Autotask/Manage/Activities/Import',
        name: 'AutotaskActivitiesImport',
        component: AutotaskActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Activities/Import',
        name: 'ClientAutotaskActivitiesImport',
        component: AutotaskActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Autotask/Manage/Opportunities/Import',
        name: 'AutotaskOpportunitiesImport',
        component: AutotaskOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Opportunities/Import',
        name: 'ClientAutotaskOpportunitiesImport',
        component: AutotaskOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    }
]